import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u445189188/domains/tasyle.com/public_html/.builds/source/tasyle/src/app/for-shoppers/components/ShoppersInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u445189188/domains/tasyle.com/public_html/.builds/source/tasyle/src/components/common/Header.tsx");
